import { RoutePath } from '@/Routes/RoutePath';

export const PageName = {
  About: 'About',
  Browse: 'Browse',
  Collection: 'Collection',
  ContentDetails: 'Content Details',
  DeviceLogin: 'Device Login',
  DeviceLogout: 'Device Logout',
  DeviceManagement: 'Device Management',
  Home: 'Home',
  LiveTv: 'Live TV',
  Login: 'Login',
  ManageDevices: 'Manage Devices',
  ManagePackages: 'Manage Packages',
  MyHub: 'My Hub',
  NotFound: 'Not Found',
  ProductDetails: 'Product Details',
  ProfileManage: 'Profile Manage',
  ProfileSelection: 'Profile Selection',
  Register: 'Register',
  Search: 'Search',
  SignOutAll: 'Sign Out All',
  TvGuide: 'TV Guide',
  Watch: 'Watch',
};

export type PageViewedAnalyticsProps = {
  path: string;
  search: string;
  title: string;
  url: string;
  name: string;
  referrer?: string;
  session_id?: string;
};

const pageViewedAnalytics = (pageName: string, payload?: PageViewedAnalyticsProps) => {
  if (!payload) {
    window.analytics?.page(pageName);
    return;
  }

  window.analytics?.page(pageName, payload);
};

export const isPathLiveTv = (path: string) => path.startsWith('/watch-tv');
export const isPathContentDetails = (path: string) =>
  path.startsWith('/show/') || path.startsWith('/movie/');

export const getPageNameByPath = (path: string) => {
  switch (path) {
    case RoutePath.home:
      return PageName.Home;
    case RoutePath.profile:
      return PageName.ProfileManage;
    case RoutePath.about:
      return PageName.About;
    case RoutePath.myHubManageDevices:
      return PageName.ManageDevices;
    case RoutePath.myHubManagePackages:
      return PageName.ManagePackages;
    case RoutePath.search:
      return PageName.Search;
    case RoutePath.login:
      return PageName.Login;
    case RoutePath.deviceLogin:
      return PageName.DeviceLogin;
    case RoutePath.deviceLogout:
      return PageName.DeviceLogout;
    case RoutePath.register:
      return PageName.Register;
    default:
      // Handle dynamic paths eg. /watch-tv/:id
      if (path.startsWith('/browse')) {
        return PageName.Browse;
      }
      if (isPathContentDetails(path)) {
        return PageName.ContentDetails;
      }
      if (path.startsWith('/watch-tv/')) {
        return PageName.LiveTv;
      }
      if (path.startsWith('/package/')) {
        return PageName.ProductDetails;
      }
      if (path.startsWith('/collection/')) {
        return PageName.Collection;
      }
      if (path.startsWith('/watch/')) {
        return PageName.Watch;
      }
      if (path.startsWith('/tv-guide')) {
        return PageName.TvGuide;
      }
      return PageName.NotFound;
  }
};

export default pageViewedAnalytics;
